function normalise(value) {
  return String(value || '').toLowerCase();
}

function hasWord(haystack, word) {
  try {
    return new RegExp(`\\b${word}\\b`, 'i').test(haystack);
  } catch {
    return haystack.includes(String(word || '').toLowerCase());
  }
}

/**
 * Client-side region inference used for admin backfills.
 * Keep this aligned with server logic.
 */
export function inferRegionFromText(text, url = '') {
  const haystack = normalise(`${url} ${text || ''}`);

  // LatAm
  if (
    hasWord(haystack, 'brazil') ||
    hasWord(haystack, 'latam') ||
    haystack.includes('latin america') ||
    hasWord(haystack, 'colombia') ||
    hasWord(haystack, 'chile') ||
    hasWord(haystack, 'peru') ||
    hasWord(haystack, 'mexico') ||
    hasWord(haystack, 'argentina')
  ) {
    return 'LatAm';
  }

  // North America
  if (
    hasWord(haystack, 'ontario') ||
    hasWord(haystack, 'canada') ||
    haystack.includes('united states') ||
    hasWord(haystack, 'usa') ||
    hasWord(haystack, 'nevada') ||
    haystack.includes('new jersey') ||
    hasWord(haystack, 'pennsylvania') ||
    haystack.includes('north america')
  ) {
    return 'North America';
  }

  // Europe (avoid false positives like "revenue" matching "eu")
  if (
    hasWord(haystack, 'uk') ||
    haystack.includes('united kingdom') ||
    hasWord(haystack, 'britain') ||
    hasWord(haystack, 'europe') ||
    hasWord(haystack, 'eu') ||
    hasWord(haystack, 'germany') ||
    hasWord(haystack, 'france') ||
    hasWord(haystack, 'spain') ||
    hasWord(haystack, 'italy') ||
    hasWord(haystack, 'sweden') ||
    hasWord(haystack, 'denmark') ||
    hasWord(haystack, 'netherlands') ||
    hasWord(haystack, 'romania') ||
    hasWord(haystack, 'ireland') ||
    hasWord(haystack, 'belgium') ||
    hasWord(haystack, 'poland') ||
    hasWord(haystack, 'czech')
  ) {
    return 'Europe';
  }

  if (
    hasWord(haystack, 'africa') ||
    hasWord(haystack, 'nigeria') ||
    hasWord(haystack, 'kenya') ||
    haystack.includes('south africa') ||
    hasWord(haystack, 'ghana') ||
    hasWord(haystack, 'morocco') ||
    hasWord(haystack, 'tanzania')
  ) {
    return 'Africa';
  }

  if (
    hasWord(haystack, 'asia') ||
    hasWord(haystack, 'macau') ||
    hasWord(haystack, 'philippines') ||
    hasWord(haystack, 'thailand') ||
    hasWord(haystack, 'vietnam') ||
    hasWord(haystack, 'japan') ||
    hasWord(haystack, 'korea') ||
    hasWord(haystack, 'singapore') ||
    hasWord(haystack, 'india')
  ) {
    return 'Asia';
  }

  if (
    hasWord(haystack, 'australia') ||
    haystack.includes('new zealand') ||
    hasWord(haystack, 'oceania')
  ) {
    return 'Australia';
  }

  return 'Global';
}


